import { Button } from "antd";
import { useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function Table2XLSX({ dataSource = [] }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    /* Callback invoked when the button is clicked */
    const xport = useCallback(async () => {
        /* Create worksheet from HTML DOM TABLE */
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);

        /* Export to file (start a download) */
        XLSX.writeFile(wb, `${t('listShop')}.xlsx`);
    }, []);

    return (<>
        <table ref={tableRef} style={{ display: 'none' }} >
            <tbody>
                <tr style={{ backgroundColor: 'red' }}>
                    <td>{t('shopCode')}</td>
                    <td>{t('shopName')}</td>
                    <td>{t('address')}</td>
                    <td>{t('departmentManager')}</td>
                    <td>{t('status')}</td>
                </tr>
                {
                    dataSource.map((row, index) => {
                        return (
                            <tr key={index}>
                                <td>{row?.code}</td>
                                <td>{row?.name}</td>
                                <td>{row?.address}</td>
                                <td>{row?.gl}</td>
                                <td>{row?.status ? t('opened') : t('planned')}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
        <Button type='primary' size="large" icon={<CloudDownloadOutlined />} onClick={xport}>{t('exportExcel')}</Button>
    </>);
}